import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'shabic-icon-excel-large-mono',
  templateUrl: './icon-excel-large-mono.component.html',
  styleUrls: ['./icon-excel-large-mono.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class IconExcelLargeMonoComponent {}
